import axios from 'axios';

const baseApiUrl: string = 'api/ad-objects';

export interface IPaginationQuery {
  page: number;
  size: number;
  sort: string[];
}

export interface IRetrieveParameter {
  criteriaQuery?: string | string[] | object;
  paginationQuery?: IPaginationQuery;
  abortController?: AbortController;
}

export default class AdObjectService {
  
  public getWindowDefinition(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/windows/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public getFieldDefinitions(tabId: number, tabPreferenceId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/fields?tabId=${tabId}&tabPreferenceId=${tabPreferenceId || 0}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
